import BaseAction from './base'

export class AppAction extends BaseAction {
    constructor(){
        super("app")
    }
}


// WEBPACK FOOTER //
// ./src/actions/app.jsx